import {
  PageTitle, Upload, BottomButtons, ErrorBar,
} from '@components';
import { ClaimType, ALLOWED_UPLOAD_TYPE, PLATFORM_NAME } from '@constants';
import { Snackbar, Alert } from '@mui/material';
import classes from './index.module.css';
import { useUpload } from './hooks';
import {
  uploadInfoMap, helpDocLink, UploadText, UPLOAD_HELP_TEXT, TITLE_TEXT, MAX_UPLOAD_AMOUNT_LIMIT,
} from './const';

export const UploadPage = () => {
  const {
    type,
    platform,
    files, files1,
    inputValue,
    isLoading,
    showToast,
    toastText,
    showFailedToast,
    failedToastText,
    totalMoney,
    comments,
    liabilitiesArr,
    onCommentsChange,
    onCloseFailedToast,
    handleChange,
    deleteFile,
    onClickContinue,
    onClickBack,
    onCloseToast,
  } = useUpload();
  const isMoreThan = [PLATFORM_NAME.SHOPPREMIUMOUTLETS, PLATFORM_NAME.NEWSPO].includes(platform) ? totalMoney >= 500 : totalMoney >= MAX_UPLOAD_AMOUNT_LIMIT;
  // loss theft 当金额大于300时，common 上传才必填附件
  const isDisabled = ([ClaimType.Loss, ClaimType.Theft].includes(type) ? (isMoreThan
    && !files.length) : !files.length) || (type === ClaimType.Damage ? !files1.length : false);
  //  garmentory/CURTSY loss 不包含theft，消费者可单独报案theft；isCommonLoss表示其他loss 包含了theft责任，但不明确指出 界面不变  0613新增，当garmentory报案theft时，如果金额不超过300，则不用上传policy report，即走原来的Upload，否则走uploadContent（https://seel.atlassian.net/browse/OP-2412）
  // 0508新增 后续不用在添加配置platform，这里统一判断liabilitiesArr有没有theft责任，没有就是common loss
  const isCommonLoss = (!([PLATFORM_NAME.GARMENTORY, PLATFORM_NAME.CURTSY, PLATFORM_NAME.GOODWILLFINDS, PLATFORM_NAME.SHOPPREMIUMOUTLETS, PLATFORM_NAME.SHOPSHOPS].includes(platform) || liabilitiesArr.includes(ClaimType.Theft)) && type === ClaimType.Loss) || (type === ClaimType.Theft && totalMoney < MAX_UPLOAD_AMOUNT_LIMIT);
  const commentPart = (number) => (
    <>
      <div className={classes.header_tip}>
        {`${number}. Enter comments explaining the issue.`}
      </div>
      <textarea
        rows={3}
        className={classes.input_comments}
        onChange={onCommentsChange}
        value={comments || ''}
        placeholder=" Max 1,000 characters"
        maxLength="1000"
      >
      </textarea>
    </>
  );

  const uploadContent = (type) => {
    const uploadList = uploadInfoMap(type, isMoreThan) || [];
    const len = uploadList.length;
    return uploadList.map((item, index) => {
      const {
        title, helpText, isRequired, moreLink, moreText,
      } = item;
      return (
        <div key={title}>
          <div className={classes.header_tip}>
            {isRequired && <span className={classes.isRequired}>*</span>}
            {title}
            {moreLink ? (
              <span>
                {' Learn more about '}
                <a className={classes.link} href={moreLink} target="_blank" rel="noreferrer">{moreText}</a>
                .
              </span>
            ) : null}

          </div>
          <Upload
            files={index ? files1 : files}
            accept={ALLOWED_UPLOAD_TYPE}
            inputValue={inputValue}
            handleChange={(e) => handleChange(e, index)}
            deleteFile={(v) => deleteFile(v, index)}
            key={title}
            style={{ boxShadow: 'initial', marginTop: 0 }}
          >
            <span>{helpText}</span>
          </Upload>

          {index === len - 1 && commentPart(len + 1)}

        </div>

      );
    });
  };

  return (
    <section className={classes.content}>
      <PageTitle title={TITLE_TEXT} />

      {/* <section className={classes.header_tip}>
        {'To qualify for a payout, please upload your supporting docs. Learn more about '}
        <a href={helpDocLink[type]} className={classes.link} target="_blank" rel="noreferrer">{`supporting docs required for your ${type} claim`}</a>
        .
      </section> */}
      <section className={classes.header_tip}>
        {'Thorough details help us understand the problem and process your claim faster. Learn more about '}
        <a href={helpDocLink.Title} className={classes.link} target="_blank" rel="noreferrer">the supporting documents</a>
        .
      </section>
      {/* 提示 toast */}
      {showToast ? (
        <ErrorBar className={classes.error} message={toastText} canClose onClose={onCloseToast} />
      ) : null}
      <div className={classes.card}>

        {isCommonLoss
          ? (
            <>
              <div>
                <div className={classes.header_tip}>
                  {UploadText[type]}
                  <a href={helpDocLink[type]} className={classes.link} target="_blank" rel="noreferrer">{`supporting docs required for your ${type} claim`}</a>
                  .
                </div>

                <Upload
                  files={files}
                  accept={ALLOWED_UPLOAD_TYPE}
                  inputValue={inputValue}
                  handleChange={handleChange}
                  deleteFile={deleteFile}
                  style={{ boxShadow: 'initial', marginTop: 0 }}
                >
                  <span>{UPLOAD_HELP_TEXT}</span>
                  {/* <span className={classes.upload_tip}>{UPLOAD_TIP}</span> */}
                </Upload>
              </div>

              {commentPart(2)}
            </>
          )
          : uploadContent(type)}
      </div>
      <BottomButtons
        isContinueDisabled={isDisabled}
        isContinueLoading={isLoading}
        onClickContinue={onClickContinue}
        onClickBack={onClickBack}
      />

      {showFailedToast ? (
        <Snackbar
          className={classes.bottom_toast}
          open={showFailedToast}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom',
          }}
          autoHideDuration={3000}
          onClose={onCloseFailedToast}
        >
          <Alert
            icon={false}
            severity="error"
            className={classes.failed_toast}
            onClose={onCloseFailedToast}
          >
            {failedToastText}
          </Alert>
        </Snackbar>
      ) : null}
    </section>
  );
};
